import React from 'react';

function TickIcon() {
  return (
    <div>
      <svg width={24} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M4 11.5L9.825 18 20 6'
          stroke='#fff'
          strokeWidth={3}
          strokeLinecap='round'
          fill='none'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  );
}

export default TickIcon;
